import styled from 'styled-components';

export const TooltipContainer = styled.div`
  position: relative;

  > div {
    position: initial;
    z-index: 0 !important;

    [role='tooltip'] {
      z-index: 3 !important;
    }
  }
`;
